// frontend/src/components/Mobile/MobileLogin.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiGrid } from 'react-icons/fi';
import './Mobile.css';

const MobileLogin = () => {
  const { login } = useAuth();
  const navigate   = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(username, password);
      // Home page = icons for the screens this user has permission to use
      navigate('/mobile', { replace: true });
    } catch (err) {
      // Stay on mobile login — show error without any redirect
      const msg = err?.response?.data?.message
               || err?.response?.data?.error
               || err?.message
               || 'Utilizador ou password incorretos.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mb-login">
      <div className="mb-login-logo">
        <FiGrid size={28} />
      </div>
      <h1>Quantix Works</h1>
      <p className="mb-login-sub">Acesso mobile</p>

      {error && <div className="mb-error">{error}</div>}

      <form className="mb-login-form" onSubmit={handleSubmit}>
        <div className="mb-field">
          <label>Utilizador</label>
          <input
            type="text"
            autoComplete="username"
            autoCapitalize="none"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="mb-field">
          <label>Password</label>
          <input
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" className="mb-btn-primary" disabled={loading}>
          {loading ? 'A entrar…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
};

export default MobileLogin;